import React from 'react';
import { TemplatesQueryProvider } from './TemplatesQueryProvider';

export const TemplatesProviders = ({ children }: any) => {
	return <TemplatesQueryProvider>{children}</TemplatesQueryProvider>;
};
